<!-- <button type="button" class="btn btn-primary pull-right mb-3"    (click)="addNewImage()">
  <ng-content></ng-content>
</button> -->

<tlp-add-attachment 
[targetImageArea]="targetImageArea" 
[lookupKey]="lookupKey"
[noOfFilesToLimit]="noOfFilesToLimit" [showDescription]="false" [showTitle]="false">Add image via modal</tlp-add-attachment>